import {useQuery} from "react-query";
import {getCustomerFromParent} from "../Api/CustomerApi";
import {Customer} from "../Types/customer";

// clé distincte de useCustomerList ('customers', liste non filtrée du sélecteur de client) : clients du périmètre courant
const QUERY_KEY = 'customers-in-scope'

export const useGetCustomers = () => {
  return useQuery<any, Error, Customer[]>(
    QUERY_KEY, () => getCustomerFromParent()
  );
}